export interface ParsedLyricLine {
  time: number // in seconds
  text: string
}

/**
 * Parse LRC formatted lyrics into an array of timed lines
 * LRC format: [MM:SS.ms]text or [MM:SS.xx]text
 */
export function parseLRC(syncedLyrics: string): ParsedLyricLine[] {
  const lines = syncedLyrics.split('\n')
  const result: ParsedLyricLine[] = []

  for (const line of lines) {
    // Match [MM:SS.xx] or [MM:SS.xxx] format
    const match = line.match(/\[(\d{2}):(\d{2})\.(\d{2,3})\](.*)/)
    if (match) {
      const minutes = parseInt(match[1], 10)
      const seconds = parseInt(match[2], 10)
      const ms = parseInt(match[3].padEnd(3, '0'), 10)
      const time = minutes * 60 + seconds + ms / 1000
      const text = match[4].trim()

      // Only add non-empty lines
      if (text) {
        result.push({ time, text })
      }
    }
  }

  // Sort by time (should already be sorted, but just in case)
  return result.sort((a, b) => a.time - b.time)
}

/**
 * Find the index of the current lyric line based on playback time
 * Returns -1 if no line is active yet
 */
export function getCurrentLyricIndex(
  lyrics: ParsedLyricLine[],
  currentTime: number
): number {
  // Find the last line where time <= currentTime
  for (let i = lyrics.length - 1; i >= 0; i--) {
    if (lyrics[i].time <= currentTime) {
      return i
    }
  }
  return -1
}
